import { writable } from "svelte/store";

if (!localStorage.user_info_list) {
    localStorage.setItem('user_info_list', JSON.stringify({}));
}

export const user_info_list = writable(JSON.parse(localStorage.user_info_list));

user_info_list.subscribe(value => {
    localStorage.user_info_list = JSON.stringify(value)
});